// /mnt/mantenimientos/frontend/src/utils/auth.js

export function getToken() {
  return String(localStorage.getItem("token") || "").trim();
}

export function authFetch(input, init = {}) {
  const token = getToken();
  const headers = new Headers(init.headers || {});

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers });
}

export function isLoggedIn() {
  return !!getToken();
}

export function authHeaders(extra = {}) {
  const token = getToken();
  const base = token ? { Authorization: `Bearer ${token}` } : {};
  return { ...base, ...extra };
}

export const ROLES = {
  TECNICO: "tecnico",
  SUPERVISOR: "supervisor",
  ADMIN: "admin",
};

export function getRol() {
  const raw = String(localStorage.getItem("rol") || "").toLowerCase().trim();

  if (raw === ROLES.TECNICO) return ROLES.TECNICO;
  if (raw === ROLES.SUPERVISOR) return ROLES.SUPERVISOR;
  if (raw === ROLES.ADMIN) return ROLES.ADMIN;

  return null;
}

export function hasRole(...allowed) {
  const rol = getRol();
  return allowed.map((r) => String(r).toLowerCase()).includes(rol);
}

export function isTecnico() {
  return getRol() === ROLES.TECNICO;
}

export function isSupervisor() {
  return [ROLES.SUPERVISOR, ROLES.ADMIN].includes(getRol());
}

/**
 * Compatibilidad para imports antiguos.
 * Si aún existiera rol=admin, aquí lo detectamos.
 */
export function isAdmin() {
  return getRol() === ROLES.ADMIN;
}

export function isPlatformAdmin() {
  return localStorage.getItem("platform_admin") === "1";
}
